import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { AppointmentApi } from "../Models/Api/Schedule";
import type { Appointment } from "../Models/Domain/Schedule";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import { camel } from "@/Utils/Camelize";

const AppointmentTransformer: TransformerExtended<Appointment, AppointmentApi> = {
  ...DefaultTransformerGenerator<Appointment, AppointmentApi>(),

  toDomain(input: AppointmentApi) {
    return camel(input);
  },
};

export type AppointmentTransformerType = TransformerExtended<Appointment, AppointmentApi>;

export default AppointmentTransformer;
